let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ll2xm")).then(() => parcelRequire('CHhGe'));